/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

window.initAccordion = function () {
  const containers = document.querySelectorAll('.accordion-section');
  if (!containers.length) return;

  containers.forEach(container => {
    const titles = container.querySelectorAll('.accordion-title');
    titles.forEach(title => {
      if (title.dataset.accordionInitialized) return;
      title.dataset.accordionInitialized = 'true';

      // Get content by aria-controls if already linked
      let contentId = title.getAttribute('aria-controls');
      let content = contentId ? document.getElementById(contentId) : null;

      // Fallback if not found or not valid
      if (!content || !content.classList.contains('accordion-content')) {
        content = title.nextElementSibling;
        const newId = `accordion-${Math.random().toString(36).substr(2, 9)}`;
        content.id = newId;
        title.setAttribute('aria-controls', newId);
      }

      // Set accessible attributes
      title.setAttribute('tabindex', '0');
      title.setAttribute('role', 'button');

      const isActive = title.classList.contains('active');
      title.setAttribute('aria-expanded', isActive);
      content.setAttribute('aria-hidden', !isActive);

const toggleAccordion = () => {
  const nowActive = !title.classList.contains('active');

  // Toggle ONLY this accordion (allow multiple open)
  title.classList.toggle('active', nowActive);
  title.setAttribute('aria-expanded', String(nowActive));
  content.setAttribute('aria-hidden', String(!nowActive));
};


      // Interaction handlers
      title.addEventListener('click', toggleAccordion);
      title.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ' || e.code === 'Space') {
          e.preventDefault();
          toggleAccordion();
        }
      });
    });
  });
};


document.addEventListener('DOMContentLoaded', function () {
  const hasAccordion = () => document.querySelector('.accordion-section');
  const isRelevantPage = () => {
    const path = window.location.pathname;
    return path.includes('/products/') || path.includes('/blogs/');
  };

  if (!isRelevantPage() || !hasAccordion()) return;

  window.initAccordion();

  // Debounced reinits on input/change events
  let debounce;
  const debouncedInit = () => {
    if (!hasAccordion()) return;
    clearTimeout(debounce);
    debounce = setTimeout(() => {
      window.initAccordion();
    }, 100);
  };

  document.body.addEventListener('change', (e) => {
    if (e.target.closest('.product-form')) debouncedInit();
  });

  document.body.addEventListener('input', (e) => {
    if (e.target.closest('.product-form')) debouncedInit();
  });

  // MutationObserver for dynamic content (e.g., translations)
  const observeTargets = document.querySelectorAll('.rte.text--pull, .product__description, main, [data-accordion]');

  observeTargets.forEach(target => {
    const observer = new MutationObserver(() => {
      if (!hasAccordion()) return;
      window.initAccordion();
    });

    observer.observe(target, {
      childList: true,
      subtree: true
    });
  });
});


(function() {
  function addAltToIcons(root) {
    root.querySelectorAll("img").forEach(function(img) {
      if (!img.hasAttribute("alt")) {
        img.setAttribute("alt", "");
      }
    });
  }

  // Initial run in case some icons are already in DOM
  addAltToIcons(document);

  // Watch for dynamically added icons
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element
          if (
            node.matches(".step-type-images, .rivo-card-icon, .rivo-th-tier-image, .launcher-desktop, .launcher-icon, .icon_with_text, .ba-met-handler") ||
            node.querySelector(".step-type-images, .rivo-card-icon, .rivo-th-tier-image, .launcher-desktop, .launcher-icon, .icon_with_text, .ba-met-handler")
          ) {
            addAltToIcons(node);
          }
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();



(() => {
  const BUTTON_SELECTOR = 'button[data-spec="toggle-button"]';
  const observedRoots = new WeakSet();

  function setAccessibleName(button) {
    if (!(button instanceof Element) || !button.matches(BUTTON_SELECTOR)) return;

    const expanded = button.getAttribute('aria-expanded') === 'true';
    const label = expanded ? 'Close chat' : 'Open chat';

    if (button.getAttribute('aria-label') !== label) {
      button.setAttribute('aria-label', label);
    }
  }

  function labelButtonsInRoot(root) {
    if (!root?.querySelectorAll) return;
    root.querySelectorAll(BUTTON_SELECTOR).forEach(setAccessibleName);
  }

  function scanForShadowRoots(node) {
    if (!(node instanceof Element)) return;

    const stack = [node];

    while (stack.length) {
      const current = stack.pop();

      if (!(current instanceof Element)) continue;

      setAccessibleName(current);

      if (current.shadowRoot) {
        observeRoot(current.shadowRoot);
      }

      for (const child of current.children) {
        stack.push(child);
      }
    }
  }

  function observeRoot(root) {
    if (!root || observedRoots.has(root)) return;
    observedRoots.add(root);

    labelButtonsInRoot(root);

    if (root instanceof Document) {
      scanForShadowRoots(root.documentElement);
    } else if (root instanceof ShadowRoot) {
      scanForShadowRoots(root.host);
      labelButtonsInRoot(root);
    }

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes') {
          setAccessibleName(mutation.target);
          continue;
        }

        for (const node of mutation.addedNodes) {
          if (node instanceof Element) {
            scanForShadowRoots(node);
          }
        }
      }
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-expanded']
    });
  }

  function initChatAccessibilityPatch() {
    observeRoot(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initChatAccessibilityPatch, { once: true });
  } else {
    initChatAccessibilityPatch();
  }
})();




(function () {
  'use strict';

  var buttonSelector = 'button#ma-make-an-offer-open-button';
  var fallbackButtonSelector = '.ma-button';
  var cardSelector = '[data-custom-make-offer-card]';
  var targetSelector = '[data-custom-make-offer-target]';
  var loadingSelector = '[data-custom-make-offer-loading]';
  var hideMarkerSelector = '[data-custom-make-offer-hide-marker]';
  var productFormSelector = '.product-form, form[action*="/cart/add"]';
  var productAreaSelector = '.product-block-list, .product-form, form[action*="/cart/add"], product-info, .product__info, .product-meta';

  var observer = null;
  var debounceTimer = null;

  function isProductPage() {
    return window.location.pathname.indexOf('/products/') !== -1;
  }

  function getOfferCard() {
    return document.querySelector(cardSelector);
  }

  function getOfferTarget() {
    var card = getOfferCard();

    if (!card) {
      return null;
    }

    return card.querySelector(targetSelector);
  }

  function getObserveRoot() {
    return document.querySelector(productAreaSelector) || document.body;
  }

  function isInsideModal(element) {
    return Boolean(element.closest('.ma-make-an-offer-modal, .ma-counter-offer-modal, dialog'));
  }

  function getOfferTrigger(target) {
    var existingStandardButton = target.querySelector(buttonSelector);

    if (existingStandardButton && !isInsideModal(existingStandardButton)) {
      return existingStandardButton;
    }

    var existingFallbackButton = target.querySelector(fallbackButtonSelector);

    if (existingFallbackButton && !isInsideModal(existingFallbackButton)) {
      return existingFallbackButton;
    }

    var standardButtons = Array.prototype.slice.call(document.querySelectorAll(buttonSelector));

    var standardButton = standardButtons.find(function (button) {
      return !target.contains(button) && !isInsideModal(button);
    });

    if (standardButton) {
      return standardButton;
    }

    var fallbackButtons = Array.prototype.slice.call(document.querySelectorAll(fallbackButtonSelector));

    var fallbackButton = fallbackButtons.find(function (button) {
      var text = (button.innerText || button.textContent || '').trim().toLowerCase();

      return (
        !target.contains(button) &&
        !isInsideModal(button) &&
        text.indexOf('make an offer') !== -1
      );
    });

    return fallbackButton || null;
  }

  function normalizeTrigger(trigger) {
    if (!trigger) {
      return;
    }

    if (trigger.matches(buttonSelector)) {
      trigger.setAttribute('type', 'button');
    }

    if (trigger.matches(fallbackButtonSelector)) {
      trigger.setAttribute('role', 'button');

      if (!trigger.hasAttribute('tabindex')) {
        trigger.setAttribute('tabindex', '0');
      }
    }
  }

  function removeLoadingText(target) {
    var loadingText = target.querySelector(loadingSelector);

    if (loadingText) {
      loadingText.remove();
    }
  }

  function hideUnusedCustomLiquidBlock() {
    var marker = document.querySelector(hideMarkerSelector);

    if (!marker) {
      return;
    }

    var blockItem = marker.closest('.product-block-list__item');

    if (
      blockItem &&
      blockItem.classList &&
      blockItem.classList.contains('product-block-list__item--content')
    ) {
      blockItem.hidden = true;
    }
  }

  function moveOfferButton() {
    var target = getOfferTarget();

    if (!target) {
      hideUnusedCustomLiquidBlock();
      return false;
    }

    var trigger = getOfferTrigger(target);

    if (!trigger) {
      return false;
    }

    normalizeTrigger(trigger);
    removeLoadingText(target);

    if (!target.contains(trigger)) {
      target.appendChild(trigger);
    }

    return true;
  }

  function startObserver() {
    var target = getOfferTarget();
    var observeRoot = getObserveRoot();

    if (!target || !observeRoot || observer) {
      return;
    }

    observer = new MutationObserver(function () {
      moveOfferButton();
    });

    observer.observe(observeRoot, {
      childList: true,
      subtree: true
    });
  }

  function refreshMakeOfferPlacement() {
    if (!isProductPage()) {
      return;
    }

    hideUnusedCustomLiquidBlock();
    moveOfferButton();
    startObserver();
  }

  function debouncedRefreshMakeOfferPlacement() {
    clearTimeout(debounceTimer);

    debounceTimer = setTimeout(function () {
      refreshMakeOfferPlacement();
    }, 150);
  }

  function bindVariantListeners() {
    document.addEventListener('variant:changed', debouncedRefreshMakeOfferPlacement);
    document.addEventListener('shopify:section:load', debouncedRefreshMakeOfferPlacement);

    if (!document.body) {
      return;
    }

    document.body.addEventListener('change', function (event) {
      if (event.target.closest(productFormSelector)) {
        debouncedRefreshMakeOfferPlacement();
      }
    });

    document.body.addEventListener('input', function (event) {
      if (event.target.closest(productFormSelector)) {
        debouncedRefreshMakeOfferPlacement();
      }
    });
  }

  function initCustomMakeOfferBlock() {
    if (!isProductPage()) {
      return;
    }

    refreshMakeOfferPlacement();
    bindVariantListeners();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomMakeOfferBlock, { once: true });
  } else {
    initCustomMakeOfferBlock();
  }
})();


/* =========================================================
   CHRISTIE LITES PREDICTIVE SEARCH NORMALIZER — v2
   Generated from the active Shopify catalog.
   Scope: predictive autocomplete only; visible input is unchanged.
   ========================================================= */
(function () {
  if (window.__clPredictiveSearchNormalizerV2) return;
  window.__clPredictiveSearchNormalizerV2 = true;

const RULES = [
  /* Additional catalog gaps confirmed through live storefront testing. */
  [
    "ayrton kamsin",
    "Khamsin S"
  ],
  [
    "kamsin s",
    "Khamsin S"
  ],
  [
    "kamsin",
    "Khamsin S"
  ],
  [
    "atomic 3k",
    "Atomic 3000 LED"
  ],
  [
    "atomic3k",
    "Atomic 3000 LED"
  ],
  [
    "grandma2 npu",
    "Network Processing Unit"
  ],
  [
    "grand ma2 npu",
    "Network Processing Unit"
  ],
  [
    "ma2 npu",
    "Network Processing Unit"
  ],
  [
    "ma npu",
    "Network Processing Unit"
  ],
  [
    "ion xe 20",
    "ION Xe"
  ],
  [
    "ion xe20",
    "ION Xe"
  ],
  [
    "ionxe 20",
    "ION Xe"
  ],
  [
    "ionxe20",
    "ION Xe"
  ],
  [
    "astera titan tube",
    "Titan Tube"
  ],
  [
    "astera titantube",
    "Titan Tube"
  ],
  [
    "six par 200",
    "SIXPAR 200"
  ],
  [
    "six par200",
    "SIXPAR 200"
  ],
  [
    "sixpar200",
    "SIXPAR 200"
  ],
  [
    "color force12",
    "Color Force 12 RGBA"
  ],
  [
    "colorforce 12",
    "Color Force 12 RGBA"
  ],
  [
    "colorforce12",
    "Color Force 12 RGBA"
  ],
  [
    "chroma q color force 12",
    "Color Force 12 RGBA"
  ],
  [
    "chroma q colorforce12",
    "Color Force 12 RGBA"
  ],
  [
    "prostar motor",
    "Quarter Ton CM Single Brake Motor"
  ],
  [
    "cm prostar motor",
    "Quarter Ton CM Single Brake Motor"
  ],
  
  [
    "grand ma 3 compact xt",
    "grandMA3 Compact"
  ],
  [
    "grand ma3 compact xt",
    "grandMA3 Compact"
  ],
  [
    "grandma 3 compact xt",
    "grandMA3 Compact"
  ],
  [
    "grandma3 compact xt",
    "grandMA3 Compact"
  ],
  [
    "gma3 compact xt",
    "grandMA3 Compact"
  ],
  [
    "ma3 compact xt",
    "grandMA3 Compact"
  ],
  [
    "hog full boar 4",
    "Full Boar 4"
  ],
  [
    "hog fullboar 4",
    "Full Boar 4"
  ],
  [
    "hog full boar",
    "Full Boar 4"
  ],
  [
    "hog fullboar",
    "Full Boar 4"
  ],
  [
    "color force 2 72",
    "CFII-72 Color Force II"
  ],
  [
    "colorforce 2 72",
    "CFII-72 Color Force II"
  ],
  [
    "colorforce2 72",
    "CFII-72 Color Force II"
  ],
  [
    "color force ii 72",
    "CFII-72 Color Force II"
  ],
  [
    "color force 2 48",
    "CFII-48 Color Force II"
  ],
  [
    "colorforce 2 48",
    "CFII-48 Color Force II"
  ],
  [
    "colorforce2 48",
    "CFII-48 Color Force II"
  ],
  [
    "color force ii 48",
    "CFII-48 Color Force II"
  ],
  [
    "color force 2 12",
    "CFII-12 Color Force II"
  ],
  [
    "colorforce 2 12",
    "CFII-12 Color Force II"
  ],
  [
    "colorforce2 12",
    "CFII-12 Color Force II"
  ],
  [
    "color force ii 12",
    "CFII-12 Color Force II"
  ],
  [
    "1ton chainhoist",
    "1 Ton Motor"
  ],
  [
    "1 ton chainhoist",
    "1 Ton Motor"
  ],
  [
    "1 ton chain hoist",
    "1 Ton Motor"
  ],
  [
    "one ton chainhoist",
    "1 Ton Motor"
  ],
  [
    "one ton chain hoist",
    "1 Ton Motor"
  ],
  [
    "2ton chainhoist",
    "2 Ton Motor"
  ],
  [
    "2 ton chainhoist",
    "2 Ton Motor"
  ],
  [
    "2 ton chain hoist",
    "2 Ton Motor"
  ],
  [
    "two ton chainhoist",
    "2 Ton Motor"
  ],
  [
    "two ton chain hoist",
    "2 Ton Motor"
  ],
  [
    "half ton chainhoist",
    "Half Ton CM Motor"
  ],
  [
    "half ton chain hoist",
    "Half Ton CM Motor"
  ],
  [
    "quarter ton chainhoist",
    "Quarter Ton CM Motor"
  ],
  [
    "quarter ton chain hoist",
    "Quarter Ton CM Motor"
  ],
  [
    "chauvette professional",
    "Chauvet Professional"
  ],
  [
    "robo spot base station",
    "RoboSpot BaseStation"
  ],
  [
    "robospot base station",
    "RoboSpot BaseStation"
  ],
  [
    "quarter ton cm motor",
    "Quarter Ton CM Motor"
  ],
  [
    "robospot basestation",
    "RoboSpot BaseStation"
  ],
  [
    "colorsource linear1",
    "ColorSource Linear 1"
  ],
  [
    "colorsource linear2",
    "ColorSource Linear 2"
  ],
  [
    "grand ma2 full size",
    "grandMA2 Full-Size 8 GB"
  ],
  [
    "grand ma3 full size",
    "grandMA3 Full size"
  ],
  [
    "colorsourcefresnel",
    "ColorSource Fresnel"
  ],
  [
    "columbus mc kinnon",
    "Columbus Mckinnon"
  ],
  [
    "grandma2 full size",
    "grandMA2 Full-Size 8 GB"
  ],
  [
    "grandma3 full size",
    "grandMA3 Full size"
  ],
  [
    "victor follow spot",
    "Victor Followspot"
  ],
  [
    "color source spot",
    "ColorSource Spot"
  ],
  [
    "columbus mckinnen",
    "Columbus Mckinnon"
  ],
  [
    "encoreperformance",
    "Encore Performance"
  ],
  [
    "grandma2 fullsize",
    "grandMA2 Full-Size 8 GB"
  ],
  [
    "grandma3 fullsize",
    "grandMA3 Full size"
  ],
  [
    "half ton cm motor",
    "Half Ton CM Motor"
  ],
  [
    "powerdistribution",
    "power distribution"
  ],
  [
    "quarter ton motor",
    "Quarter Ton motor"
  ],
  [
    "singlebrake motor",
    "single brake motor"
  ],
  [
    "bmfl follow spot",
    "BMFL FollowSpot"
  ],
  [
    "columbus mckinon",
    "Columbus Mckinnon"
  ],
  [
    "domino profile s",
    "Domino Profile S"
  ],
  [
    "grandma3 compact",
    "grandMA3 Compact"
  ],
  [
    "one ton cm motor",
    "1 Ton CM Motor"
  ],
  [
    "proteusexcalibur",
    "Proteus Excalibur"
  ],
  [
    "source 4 fresnel",
    "Source Four Fresnel"
  ],
  [
    "ultraperformance",
    "Ultra Performance"
  ],
  [
    "viperperformance",
    "Viper Performance"
  ],
  [
    "atmospherehazer",
    "Atmosphere Hazer"
  ],
  [
    "atomic 3000 led",
    "Atomic 3000 LED"
  ],
  [
    "cobra 18 fogger",
    "Cobra 1.8 Fogger"
  ],
  [
    "colorsourcespot",
    "ColorSource Spot"
  ],
  [
    "colour kinetics",
    "Color Kinetics"
  ],
  [
    "domino profiles",
    "Domino Profile S"
  ],
  [
    "high end system",
    "High End Systems"
  ],
  [
    "highend systems",
    "High End Systems"
  ],
  [
    "robert juliette",
    "Robert Juliat"
  ],
  [
    "sourcefour leko",
    "Source Four Leko"
  ],
  [
    "viper 26 fogger",
    "Viper 2.6 Fogger"
  ],
  [
    "vizi beam 12 rx",
    "Vizi Beam 12RX"
  ],
  [
    "1 ton cm motor",
    "1 Ton CM Motor"
  ],
  [
    "bmfl wash beam",
    "BMFL WashBeam"
  ],
  [
    "bmflfollowspot",
    "BMFL FollowSpot"
  ],
  [
    "color kinetics",
    "Color Kinetics"
  ],
  [
    "gma2 full size",
    "grandMA2 Full-Size 8 GB"
  ],
  [
    "gma3 full size",
    "grandMA3 Full size"
  ],
  [
    "grand ma2 lite",
    "grandMA2 Light"
  ],
  [
    "grand ma3 lite",
    "grandMA3 Light"
  ],
  [
    "half ton motor",
    "Half Ton motor"
  ],
  [
    "proteusmaximus",
    "Proteus Maximus"
  ],
  [
    "quantumprofile",
    "Quantum Profile"
  ],
  [
    "quarter ton cm",
    "Quarter Ton CM"
  ],
  [
    "rayzor blade l",
    "Rayzor Blade L"
  ],
  [
    "sunstripactive",
    "Sunstrip Active"
  ],
  [
    "vector console",
    "VECTOR console"
  ],
  [
    "1/2 ton motor",
    "Half Ton motor"
  ],
  [
    "1/4 ton motor",
    "Quarter Ton motor"
  ],
  [
    "1ton cm motor",
    "1 Ton CM Motor"
  ],
  [
    "color force 2",
    "Color Force II"
  ],
  [
    "cyberlightled",
    "Cyberlight LED"
  ],
  [
    "desirefresnel",
    "Desire Fresnel"
  ],
  [
    "double reeved",
    "double Reeved"
  ],
  [
    "gigacore 14 r",
    "GigaCore 14R"
  ],
  [
    "grandma2 lite",
    "grandMA2 Light"
  ],
  [
    "grandma3 lite",
    "grandMA3 Light"
  ],
  [
    "look solution",
    "LOOK Solutions"
  ],
  [
    "looksolutions",
    "LOOK Solutions"
  ],
  [
    "ma2 full size",
    "grandMA2 Full-Size 8 GB"
  ],
  [
    "ma3 full size",
    "grandMA3 Full size"
  ],
  [
    "one ton motor",
    "1 Ton motor"
  ],
  [
    "opto splitter",
    "Opto-Splitter"
  ],
  [
    "proteusbrutus",
    "Proteus Brutus"
  ],
  [
    "proteushybrid",
    "Proteus Hybrid"
  ],
  [
    "proteusradius",
    "Proteus Radius"
  ],
  [
    "proteusrayzor",
    "Proteus Rayzor"
  ],
  [
    "radiancehazer",
    "Radiance Hazer"
  ],
  [
    "robert juliet",
    "Robert Juliat"
  ],
  [
    "series2 lustr",
    "Series 2 Lustr"
  ],
  [
    "series3 lustr",
    "Series 3 Lustr"
  ],
  [
    "sky panel s30",
    "SkyPanel S30"
  ],
  [
    "sky panel s60",
    "SkyPanel S60"
  ],
  [
    "skypanel s30c",
    "SkyPanel S30-C"
  ],
  [
    "skypanel s60c",
    "SkyPanel S60-C"
  ],
  [
    "socapex motor",
    "Socapex motor"
  ],
  [
    "source 4 leko",
    "Source Four Leko"
  ],
  [
    "two ton motor",
    "2 Ton motor"
  ],
  [
    "axiom hibrid",
    "Axiom Hybrid"
  ],
  [
    "axiom hybird",
    "axiom hybrid"
  ],
  [
    "axiom hybred",
    "Axiom Hybrid"
  ],
  [
    "bmflwashbeam",
    "BMFL WashBeam"
  ],
  [
    "color source",
    "ColorSource"
  ],
  [
    "colorblast12",
    "ColorBlast 12"
  ],
  [
    "colorblaze48",
    "ColorBlaze 48"
  ],
  [
    "colorblaze72",
    "ColorBlaze 72"
  ],
  [
    "colour force",
    "Color Force"
  ],
  [
    "double reeve",
    "double Reeved"
  ],
  [
    "eos titanium",
    "EOS Ti"
  ],
  [
    "fos4 fresnel",
    "Fos/4 Fresnel"
  ],
  [
    "hazemachines",
    "haze machines"
  ],
  [
    "impressionx4",
    "impression X4"
  ],
  [
    "impressionx5",
    "impression X5"
  ],
  [
    "kinesysmotor",
    "Kinesys motor"
  ],
  [
    "light master",
    "LightMaster"
  ],
  [
    "ma2 fullsize",
    "grandMA2 Full-Size 8 GB"
  ],
  [
    "ma3 fullsize",
    "grandMA3 Full size"
  ],
  [
    "mac aura pxl",
    "MAC Aura PXL"
  ],
  [
    "magicbladefx",
    "MagicBlade FX"
  ],
  [
    "magicpanel r",
    "MagicPanel-R"
  ],
  [
    "motor distro",
    "Motor Distro"
  ],
  [
    "optosplitter",
    "Opto-Splitter"
  ],
  [
    "paladinpanel",
    "Paladin Panel"
  ],
  [
    "platinumbeam",
    "Platinum Beam"
  ],
  [
    "proteusatlas",
    "Proteus Atlas"
  ],
  [
    "proteusodeon",
    "Proteus Odeon"
  ],
  [
    "smartfade ml",
    "SmartFade ML"
  ],
  [
    "smartyhybrid",
    "Smarty Hybrid"
  ],
  [
    "source 4 led",
    "Source Four LED"
  ],
  [
    "vdo sceptron",
    "VDO Sceptron"
  ],
  [
    "viper washdx",
    "Viper Wash DX"
  ],
  [
    "viperprofile",
    "Viper Profile"
  ],
  [
    "wild sun s25",
    "WildSun S25"
  ],
  [
    "axiomhybrid",
    "Axiom Hybrid"
  ],
  [
    "chainhoists",
    "chain hoists"
  ],
  [
    "chainmotors",
    "chain motors"
  ],
  [
    "color blast",
    "ColorBlast"
  ],
  [
    "colorforce2",
    "Color Force II"
  ],
  [
    "colorsource",
    "ColorSource"
  ],
  [
    "colourforce",
    "Color Force"
  ],
  [
    "commandwing",
    "Command Wing"
  ],
  [
    "cyber light",
    "Cyberlight"
  ],
  [
    "df-50 hazer",
    "DF-50 Diffusion Hazer"
  ],
  [
    "encore perf",
    "Encore Performance"
  ],
  [
    "fine 1200 c",
    "FINE 1200C"
  ],
  [
    "fogmachines",
    "fog machines"
  ],
  [
    "follow spot",
    "followspot"
  ],
  [
    "fuzeprofile",
    "Fuze Profile"
  ],
  [
    "gigacore 10",
    "GigaCore10"
  ],
  [
    "gigacore14r",
    "GigaCore 14R"
  ],
  [
    "half ton cm",
    "Half Ton CM"
  ],
  [
    "hazemachine",
    "haze machine"
  ],
  [
    "hydra panel",
    "HydraPanel"
  ],
  [
    "kl fresnel6",
    "KL Fresnel 6"
  ],
  [
    "kl fresnel8",
    "KL Fresnel 8"
  ],
  [
    "ma3 compact",
    "grandMA3 Compact"
  ],
  [
    "magic blade",
    "MagicBlade"
  ],
  [
    "magic panel",
    "MagicPanel"
  ],
  [
    "magicpanler",
    "MagicPanel-R"
  ],
  [
    "me 2 fogger",
    "Me2 Fogger"
  ],
  [
    "mini xtylos",
    "Mini Xtylos"
  ],
  [
    "nomad puck2",
    "Nomad Puck v2"
  ],
  [
    "nomad puck3",
    "Nomad Puck v3"
  ],
  [
    "orbiterbeam",
    "Orbiter Beam"
  ],
  [
    "paladincube",
    "Paladin Cube"
  ],
  [
    "pixel bar30",
    "Pixel Bar 30"
  ],
  [
    "pixel brick",
    "PixelBrick"
  ],
  [
    "platinum 5r",
    "Platinum Beam 5R"
  ],
  [
    "powerdistro",
    "power distro"
  ],
  [
    "quantumwash",
    "Quantum Wash"
  ],
  [
    "rayzorblade",
    "Rayzor Blade"
  ],
  [
    "sceptron 10",
    "Sceptron 10"
  ],
  [
    "sensor rack",
    "Sensor Rack"
  ],
  [
    "sola hybeam",
    "SolaHyBeam"
  ],
  [
    "spikey plus",
    "Spikie Plus"
  ],
  [
    "titan tubes",
    "Titan Tube"
  ],
  [
    "viperwashdx",
    "Viper Wash DX"
  ],
  [
    "1ton motor",
    "1 Ton motor"
  ],
  [
    "2ton motor",
    "2 Ton motor"
  ],
  [
    "7pin motor",
    "7 Pin motor"
  ],
  [
    "atomic3000",
    "Atomic 3000"
  ],
  [
    "atomicbold",
    "Atomic Bold"
  ],
  [
    "black trax",
    "BlackTrax"
  ],
  [
    "bmfl blade",
    "BMFL Blade"
  ],
  [
    "chainhoist",
    "chain hoist"
  ],
  [
    "chainmotor",
    "chain motor"
  ],
  [
    "clay pakey",
    "Clay Paky"
  ],
  [
    "colorblast",
    "ColorBlast"
  ],
  [
    "colorforce",
    "Color Force"
  ],
  [
    "cyc lights",
    "cyc lights"
  ],
  [
    "eclipse fs",
    "EclipseFS"
  ],
  [
    "elevation1",
    "Elevation 1"
  ],
  [
    "encorewash",
    "Encore Wash"
  ],
  [
    "fogmachine",
    "fog machine"
  ],
  [
    "full boar4",
    "Full Boar 4"
  ],
  [
    "fuzeteatro",
    "Fuze Teatro"
  ],
  [
    "gigacore10",
    "GigaCore10"
  ],
  [
    "gma2 light",
    "grandMA2 Light"
  ],
  [
    "gma3 light",
    "grandMA3 Light"
  ],
  [
    "hydrapanel",
    "HydraPanel"
  ],
  [
    "m9 fog jet",
    "M 9 Fog Jet"
  ],
  [
    "macquantum",
    "MAC Quantum"
  ],
  [
    "minixtylos",
    "Mini Xtylos"
  ],
  [
    "nomadpuck2",
    "Nomad Puck v2"
  ],
  [
    "nomadpuck3",
    "Nomad Puck v3"
  ],
  [
    "pixelbar30",
    "Pixel Bar 30"
  ],
  [
    "pixelbrick",
    "PixelBrick"
  ],
  [
    "rayzor1960",
    "Rayzor 1960"
  ],
  [
    "s4 fresnel",
    "Source Four Fresnel"
  ],
  [
    "sceptron10",
    "Sceptron 10"
  ],
  [
    "sensorrack",
    "Sensor Rack"
  ],
  [
    "sharpywash",
    "Sharpy Wash"
  ],
  [
    "sixbar1000",
    "SIXBAR 1000"
  ],
  [
    "smart fade",
    "SmartFade"
  ],
  [
    "smart pack",
    "SmartPack"
  ],
  [
    "solahybeam",
    "SolaHyBeam"
  ],
  [
    "sonic boom",
    "SonicBoom"
  ],
  [
    "sourcefour",
    "Source Four"
  ],
  [
    "spikieplus",
    "Spikie Plus"
  ],
  [
    "strikebolt",
    "STRIKE Bolt"
  ],
  [
    "unique 2 1",
    "Unique 2-1"
  ],
  [
    "unique 2.1",
    "Unique 2-1"
  ],
  [
    "viperairfx",
    "Viper AirFX"
  ],
  [
    "wildsuns25",
    "WildSun S25"
  ],
  [
    "xtylos hpe",
    "Xtylos HPE"
  ],
  
  [
    "acl360",
    "ACL 360i"
  ],

  [
    "acl 360 i",
    "ACL 360i"
  ],
  [
    "array 485",
    "ARRAY 485"
  ],
  [
    "atomicdot",
    "Atomic Dot"
  ],
  [
    "blacktrax",
    "BlackTrax"
  ],
  [
    "bmflblade",
    "BMFL Blade"
  ],
  [
    "chauvette",
    "Chauvet"
  ],
  [
    "cm motors",
    "CM motors"
  ],
  [
    "cyc light",
    "cyc light"
  ],
  [
    "cyclights",
    "cyc lights"
  ],
  [
    "dbl reeve",
    "Dbl Reeved"
  ],
  [
    "eclipsefs",
    "EclipseFS"
  ],
  [
    "f 7 smaze",
    "F 7 SMAZE"
  ],
  [
    "f-7 smaze",
    "F 7 SMAZE"
  ],
  [
    "faderwing",
    "Fader Wing"
  ],
  [
    "fine1200c",
    "FINE 1200C"
  ],
  [
    "fr 10 bar",
    "FR10 Bar"
  ],
  [
    "fr-10 bar",
    "FR10 Bar"
  ],
  [
    "fullboar4",
    "Full Boar 4"
  ],
  [
    "grand ma2",
    "grandMA2"
  ],
  [
    "grand ma3",
    "grandMA3"
  ],
  [
    "grandma 2",
    "grandMA2"
  ],
  [
    "grandma 3",
    "grandMA3"
  ],
  [
    "impresion",
    "impression"
  ],
  [
    "impresson",
    "impression"
  ],
  [
    "klfresnel",
    "KL Fresnel"
  ],
  [
    "klprofile",
    "KL Profile"
  ],
  [
    "luminode1",
    "LumiNode 1"
  ],
  [
    "luminode2",
    "LumiNode 2"
  ],
  [
    "luminode4",
    "LumiNode 4"
  ],
  [
    "ma2 on pc",
    "MA2 onPC"
  ],
  [
    "macencore",
    "MAC Encore"
  ],
  [
    "magma fan",
    "MagmaFan"
  ],
  [
    "me2fogger",
    "Me2 Fogger"
  ],
  [
    "nomadpuck",
    "Nomad Puck"
  ],
  [
    "paragonlt",
    "Paragon LT"
  ],
  [
    "path port",
    "Pathport"
  ],
  [
    "rayzor760",
    "Rayzor 760"
  ],
  [
    "robo spot",
    "RoboSpot"
  ],
  [
    "show baby",
    "SHoW BABY"
  ],
  [
    "sky panel",
    "SkyPanel"
  ],
  [
    "smartpack",
    "SmartPack"
  ],
  [
    "smartymax",
    "Smarty Max"
  ],
  [
    "smoke jet",
    "SmokeJet"
  ],
  [
    "sola spot",
    "SolaSpot"
  ],
  [
    "sonicboom",
    "SonicBoom"
  ],
  [
    "spot rack",
    "Spotrack"
  ],
  [
    "spottrack",
    "Spotrack"
  ],
  [
    "sun strip",
    "Sunstrip"
  ],
  [
    "t2profile",
    "T2 Profile"
  ],
  [
    "titantube",
    "Titan Tube"
  ],
  [
    "ultrawash",
    "Ultra Wash"
  ],
  [
    "unique2-1",
    "Unique 2-1"
  ],
  [
    "unique2.1",
    "Unique 2-1"
  ],
  [
    "vdoatomic",
    "VDO Atomic"
  ],
  [
    "vesuvio 2",
    "Vesuvio II"
  ],
  [
    "viperwash",
    "Viper Wash"
  ],
  [
    "wash beam",
    "WashBeam"
  ],
  [
    "art 2000",
    "ART 2000"
  ],
  [
    "aura pxl",
    "Aura PXL"
  ],
  [
    "chroma-q",
    "Chroma Q"
  ],
  [
    "claypaky",
    "Clay Paky"
  ],
  [
    "cm motor",
    "CM motor"
  ],
  [
    "cobra1.8",
    "Cobra 1.8"
  ],
  [
    "cryo fog",
    "CRYO FOG"
  ],
  [
    "cyclight",
    "cyc light"
  ],
  [
    "diablo s",
    "Diablo-S"
  ],
  [
    "eos apex",
    "EOS Apex"
  ],
  [
    "f7 smaze",
    "F 7 SMAZE"
  ],
  [
    "fullboar",
    "Full Boar"
  ],
  [
    "fuzewash",
    "Fuze Wash"
  ],
  [
    "grand ma",
    "grandMA"
  ],
  [
    "hog 4 18",
    "Hog 4-18"
  ],
  [
    "kl cyc s",
    "KL Cyc S"
  ],
  [
    "librapro",
    "LibraPRO"
  ],
  [
    "lift ket",
    "Liftket"
  ],
  [
    "luster 2",
    "Lustr 2"
  ],
  [
    "m9fogjet",
    "M 9 Fog Jet"
  ],
  [
    "ma2 lite",
    "grandMA2 Light"
  ],
  [
    "ma3 lite",
    "grandMA3 Light"
  ],
  [
    "macaxiom",
    "MAC Axiom"
  ],
  [
    "macultra",
    "MAC Ultra"
  ],
  [
    "macviper",
    "MAC Viper"
  ],
  [
    "magmafan",
    "MagmaFan"
  ],
  [
    "midgethp",
    "Midget HP"
  ],
  [
    "paragonm",
    "Paragon M"
  ],
  [
    "paragons",
    "Paragon S"
  ],
  [
    "pathport",
    "Pathport"
  ],
  [
    "proteous",
    "proteus"
  ],
  [
    "robospot",
    "RoboSpot"
  ],
  [
    "showbaby",
    "SHoW BABY"
  ],
  [
    "skypanel",
    "SkyPanel"
  ],
  [
    "smokejet",
    "SmokeJet"
  ],
  [
    "solaspot",
    "SolaSpot"
  ],
  [
    "source 4",
    "Source Four"
  ],
  [
    "strike 1",
    "STRIKE 1"
  ],
  [
    "unique21",
    "Unique 2-1"
  ],
  [
    "vesuvio2",
    "Vesuvio II"
  ],
  [
    "viper2.6",
    "Viper 2.6"
  ],
  [
    "vizi12rx",
    "Vizi Beam 12RX"
  ],
  [
    "vizibeam",
    "Vizi Beam"
  ],
  [
    "wild sun",
    "WildSun"
  ],
  [
    "x4 bar10",
    "X4 Bar 10"
  ],
  [
    "x4 bar20",
    "X4 Bar 20"
  ],
  [
    "5r beam",
    "5R Beam"
  ],
  [
    "acl360i",
    "ACL 360i"
  ],
  [
    "apex 10",
    "Apex 10"
  ],
  [
    "arraypd",
    "ARRAY PD"
  ],
  [
    "art2000",
    "ART 2000"
  ],
  [
    "aura xb",
    "Aura XB"
  ],
  [
    "aurapxl",
    "Aura PXL"
  ],
  [
    "cemplus",
    "CEM Plus"
  ],
  [
    "chromaq",
    "Chroma Q"
  ],
  [
    "cryofog",
    "CRYO FOG"
  ],
  [
    "cue pix",
    "CUEPIX"
  ],
  [
    "diablos",
    "Diablo-S"
  ],
  [
    "dp-8000",
    "DP 8000"
  ],
  [
    "eosapex",
    "EOS Apex"
  ],
  [
    "era 800",
    "ERA 800"
  ],
  [
    "f7smaze",
    "F 7 SMAZE"
  ],
  [
    "fortefs",
    "Forte FS"
  ],
  [
    "fr10bar",
    "FR10 Bar"
  ],
  [
    "fuzemax",
    "Fuze Max"
  ],
  [
    "fuzesfx",
    "Fuze SFX"
  ],
  [
    "hog4 18",
    "Hog 4-18"
  ],
  [
    "i forte",
    "iForte"
  ],
  [
    "klpanel",
    "KL Panel"
  ],
  [
    "liftket",
    "Liftket"
  ],
  [
    "ma onpc",
    "MA onPC"
  ],
  [
    "ma2onpc",
    "MA2 onPC"
  ],
  [
    "mac 101",
    "MAC 101"
  ],
  [
    "mac 350",
    "MAC 350"
  ],
  [
    "mac 700",
    "MAC 700"
  ],
  [
    "mac iii",
    "MAC III"
  ],
  [
    "max3000",
    "MAX 3000"
  ],
  [
    "max5000",
    "MAX 5000"
  ],
  [
    "protues",
    "proteus"
  ],
  [
    "quantam",
    "quantum"
  ],
  [
    "s4 leko",
    "Source Four Leko"
  ],
  [
    "socopex",
    "socapex"
  ],
  [
    "source4",
    "Source Four"
  ],
  [
    "strike1",
    "STRIKE 1"
  ],
  [
    "x 4 bar",
    "X4 Bar"
  ],
  [
    "x4bar10",
    "X4 Bar 10"
  ],
  [
    "x4bar20",
    "X4 Bar 20"
  ],
  [
    "air fx",
    "AirFX"
  ],
  [
    "air-fx",
    "AirFX"
  ],
  [
    "apex10",
    "Apex 10"
  ],
  [
    "auraxb",
    "Aura XB"
  ],
  [
    "cfii12",
    "CFII-12"
  ],
  [
    "cfii48",
    "CFII-48"
  ],
  [
    "cfii72",
    "CFII-72"
  ],
  [
    "cuepix",
    "CUEPIX"
  ],
  [
    "dp8000",
    "DP 8000"
  ],
  [
    "eos ti",
    "EOS Ti"
  ],
  [
    "era800",
    "ERA 800"
  ],
  [
    "hibrid",
    "hybrid"
  ],
  [
    "hybird",
    "hybrid"
  ],
  [
    "hybred",
    "hybrid"
  ],
  [
    "hz 500",
    "HZ 500"
  ],
  [
    "iforte",
    "iForte"
  ],
  [
    "lowfog",
    "low fog"
  ],
  [
    "lustr2",
    "Lustr 2"
  ],
  [
    "mac101",
    "MAC 101"
  ],
  [
    "mac350",
    "MAC 350"
  ],
  [
    "mac700",
    "MAC 700"
  ],
  [
    "nxwing",
    "NX Wing"
  ],
  [
    "quatum",
    "quantum"
  ],
  [
    "rayzer",
    "rayzor"
  ],
  [
    "s4 led",
    "Source Four LED"
  ],
  [
    "s4leko",
    "Source Four Leko"
  ],
  [
    "x 4 xl",
    "X4 XL"
  ],
  [
    "12 rx",
    "12RX"
  ],
  [
    "12-rx",
    "12RX"
  ],
  [
    "cem 3",
    "CEM3"
  ],
  [
    "cem-3",
    "CEM3"
  ],
  [
    "cf 48",
    "CF-48"
  ],
  [
    "df 50",
    "DF-50"
  ],
  [
    "fos 4",
    "Fos/4"
  ],
  [
    "fr-10",
    "FR10"
  ],
  [
    "gio 5",
    "Gio @5"
  ],
  [
    "gio@5",
    "Gio @5"
  ],
  [
    "hog 4",
    "Hog 4"
  ],
  [
    "hz500",
    "HZ 500"
  ],
  [
    "ionxe",
    "ION Xe"
  ],
  [
    "jdc 1",
    "JDC1"
  ],
  [
    "jdc 2",
    "JDC2"
  ],
  [
    "jdc-1",
    "JDC1"
  ],
  [
    "jdc-2",
    "JDC2"
  ],
  [
    "klcyc",
    "KL Cyc"
  ],
  [
    "m2 go",
    "M2GO"
  ],
  [
    "m2-go",
    "M2GO"
  ],
  [
    "mac 3",
    "MAC III"
  ],
  [
    "on pc",
    "onPC"
  ],
  [
    "on-pc",
    "onPC"
  ],
  [
    "rpu 3",
    "RPU3"
  ],
  [
    "rpu-3",
    "RPU3"
  ],
  [
    "smaze",
    "SMAZE"
  ],
  [
    "x 4 s",
    "X4 S"
  ],
  [
    "x4bar",
    "X4 Bar"
  ],
  [
    "zr 25",
    "ZR25"
  ],
  [
    "zr 44",
    "ZR44"
  ],
  [
    "zr-25",
    "ZR25"
  ],
  [
    "zr-44",
    "ZR44"
  ],
  [
    "zw 19",
    "ZW19"
  ],
  [
    "zw 37",
    "ZW37"
  ],
  [
    "zw-19",
    "ZW19"
  ],
  [
    "zw-37",
    "ZW37"
  ],
  [
    "cfii",
    "Color Force II"
  ],
  [
    "crmx",
    "CRMX"
  ],
  [
    "df50",
    "DF-50"
  ],
  [
    "fos4",
    "Fos/4"
  ],
  [
    "fr 1",
    "FR1"
  ],
  [
    "fr10",
    "FR10"
  ],
  [
    "gio5",
    "Gio @5"
  ],
  [
    "gma2",
    "grandMA2"
  ],
  [
    "gma3",
    "grandMA3"
  ],
  [
    "hog4",
    "Hog 4"
  ],
  [
    "jdc1",
    "JDC1"
  ],
  [
    "jdc2",
    "JDC2"
  ],
  [
    "m2go",
    "M2GO"
  ],
  [
    "ma 2",
    "grandMA2"
  ],
  [
    "ma 3",
    "grandMA3"
  ],
  [
    "mac3",
    "MAC III"
  ],
  [
    "nx 1",
    "NX1"
  ],
  [
    "nx 2",
    "NX2"
  ],
  [
    "nx 4",
    "NX4"
  ],
  [
    "nx-1",
    "NX1"
  ],
  [
    "nx-2",
    "NX2"
  ],
  [
    "nx-4",
    "NX4"
  ],
  [
    "x4xl",
    "X4 XL"
  ],
  [
    "zr25",
    "ZR25"
  ],
  [
    "zr44",
    "ZR44"
  ],
  [
    "cf2",
    "Color Force II"
  ],
  [
    "gm2",
    "grandMA2"
  ],
  [
    "gm3",
    "grandMA3"
  ],
  [
    "ma2",
    "grandMA2"
  ],
  [
    "ma3",
    "grandMA3"
  ],
  [
    "x4s",
    "X4 S"
  ],
    [
    "F 7 SMAZE ",
    "F7","f7"

  ]
];

  function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function normalizeQuery(query) {
    const lookup = Object.create(null);
    RULES.forEach(function (rule) {
      lookup[rule[0].toLowerCase()] = rule[1];
    });

    const alternatives = RULES.map(function (rule) {
      return escapeRegExp(rule[0]);
    }).join("|");

    const pattern = new RegExp(
      "(^|[^a-z0-9])(" + alternatives + ")(?=$|[^a-z0-9])",
      "gi"
    );

    return query.replace(pattern, function (match, prefix, alternate) {
      return prefix + lookup[alternate.toLowerCase()];
    }).replace(/\s{2,}/g, " ").trim();
  }

  const originalFetch = window.fetch;

  window.fetch = function () {
    const args = Array.from(arguments);
    const resource = args[0];

    if (typeof resource !== "string" || !resource.includes("/search/suggest")) {
      return originalFetch.apply(this, args);
    }

    try {
      const url = new URL(resource, window.location.origin);
      const originalQuery = url.searchParams.get("q");

      if (!originalQuery) return originalFetch.apply(this, args);

      const separator = " AND ";
      const splitAt = originalQuery.lastIndexOf(separator);
      const prefix = splitAt >= 0 ? originalQuery.slice(0, splitAt + separator.length) : "";
      const customerQuery = splitAt >= 0 ? originalQuery.slice(splitAt + separator.length) : originalQuery;
      const normalizedQuery = prefix + normalizeQuery(customerQuery);

      if (normalizedQuery !== originalQuery) {
        url.searchParams.set("q", normalizedQuery);
        args[0] = url.pathname + url.search;
      }
    } catch (error) {}

    return originalFetch.apply(this, args);
  };

})();